import React, { Component, Fragment } from 'react';
import styles from './PlayerContainer.module.css';
import { Tab, Tabs, TabList } from 'react-tabs';
import Player from '../Player';
import ReactSelect from 'react-select';
import StreamingPlayer from '../StreamingPlayer';

export default class PlayerContainer extends Component {
  state = {
    asset: null,
    assetType: 'high',
    renderType: 'webgl',
    selectedIndex: 0,
    materialDiffuse: null,
    dropText: 'Drag and drop your model file(s) here.',
  };

  componentWillReceiveProps(props) {}

  onSelect(idx) {
    const { item } = this.props;
    this.setState({ selectedIndex: idx, asset: item.assets[idx] });
  }

  onDrop = data => {
    const { onDrop } = this.props;
    const file = data && data[0];
    this.setState({ dropText: `Uploading ${file.name}...` });
    onDrop(file).then(uploadResult =>
      this.setState({ dropText: uploadResult })
    );
  };

  viewAssets = type => {
    const { item } = this.props;
    const newAssets = item.assets.filter(item =>
      this.filterAssetType(item, type)
    );

    this.setState({
      assetType: type,
      asset: newAssets.slice(-1).pop(),
      selectedIndex: newAssets.length - 1,
    });
  };

  componentDidMount() {
    const { item } = this.props;
    let { assetType } = this.state;
    let displayAssets = item.assets.filter(item =>
      this.filterAssetType(item, assetType)
    );
    if (displayAssets.length === 0) {
      assetType = 'low';
      displayAssets = item.assets.filter(item =>
        this.filterAssetType(item, assetType)
      );
    }
    this.setState({
      assetType,
      asset: displayAssets.slice(-1).pop(),
      selectedIndex: displayAssets.length - 1,
      materialDiffuse: item.thumbnail,
    });
  }

  filterAssetType = (item, assetType) => {
    if (assetType === 'low') return item.assetType === assetType;
    else {
      return !item.assetType || item.assetType === 'high';
    }
  };

  renderModel() {
    const { initializePlayer, catogary, item, takeSnapshot } = this.props;
    const { selectedIndex, asset, assetType, renderType } = this.state;
    if (!asset)
      return (
        <div className={styles.container}>
          <p className={styles.noAssets}> No assets have been uploaded </p>
        </div>
      );
    return (
      <Fragment>
        <Tabs onSelect={this.onSelect.bind(this)} selectedIndex={selectedIndex}>
          <TabList style={{ margin: 0 }}>
            {item.assets
              .filter(item =>
                assetType === 'low'
                  ? item.assetType === assetType
                  : !item.assetType || item.assetType === 'high'
              )
              .map((v, k) => (
                <Tab
                  style={{
                    width: 50,
                    height: 30,
                    textAlign: 'center',
                    borderRadius: 0,
                    backgroundColor: selectedIndex === k ? 'white' : '#f7f7f7',
                    borderColor: '#aaa',
                    borderBottom: selectedIndex === k ? 'none' : 'inherit',
                    bottom: '-2px',
                  }}
                >
                  <span className={styles.tabTitle}>v{k + 1}</span>
                </Tab>
              ))}
          </TabList>
          <Player
            asset={asset}
            catogary={catogary}
            initializePlayer={initializePlayer}
          />
        </Tabs>
      </Fragment>
    );
  }

  viewMateirals = data => {
    this.setState({ materialDiffuse: data && data.value });
  };

  renderMaterial() {
    const { item, output } = this.props;
    const { materialDiffuse } = this.state;
    if (!item.assets.length)
      return (
        <div className={styles.noAssets}>
          <p>No Assets have been uploaded</p>
        </div>
      );
    const swatch = item.metadata.Swatch;
    return (
      <div className={styles.container}>
        <div className={styles.label}>Version</div>
        <ReactSelect
          className={styles.select}
          options={item.assets.map((item, k) => ({
            label: `Version ${k + 1}`,
            value: `${item && item.thumbnail}&version=${k}`,
          }))}
          onChange={this.viewMateirals}
          value={materialDiffuse}
        />
        {swatch && (
          <div>
            <div className={styles.title}> Reference Swatch </div>
            <img
              ref="swatchImage"
              className={styles.thumbnail}
              src={swatch}
              onError={e =>
                (this.refs['swatchImage'].src = '/img/noimage.jpeg')
              }
            />
          </div>
        )}
        {materialDiffuse && (
          <div>
            <div className={styles.title}> Material </div>
            <img
              ref="diffuseImage"
              className={styles.thumbnail}
              src={materialDiffuse}
              onError={e =>
                (this.refs['diffuseImage'].src = '/img/noimage.jpeg')
              }
            />
          </div>
        )}
        {output && <div> Model Sample1 </div>}
      </div>
    );
  }

  renderScene() {
    const {
      enterVray,
      exitVray,
      applyConfigs,
      changeModel,
      item,
      fetchModels,
      fetchMaterials,
      fetchProducts,
      streamingError,
      savePublished,
      createJob,
      setStreamingMode,
      streamingMode,
      streaming,
      rotateModel,
      moveModel,
      cameraOperation,
    } = this.props;
    return (
      <Fragment>
        <StreamingPlayer
          item={item}
          enterVray={enterVray}
          exitVray={exitVray}
          fetchMaterials={fetchMaterials}
          applyConfigs={applyConfigs}
          changeModel={changeModel}
          fetchProducts={fetchProducts}
          fetchModels={fetchModels}
          streamingError={streamingError}
          savePublished={savePublished}
          createJob={createJob}
          setStreamingMode={setStreamingMode}
          streamingMode={streamingMode}
          streaming={streaming}
          moveModel={moveModel}
          rotateModel={rotateModel}
          cameraOperation={cameraOperation}
        />
      </Fragment>
    );
  }

  render() {
    const { catogary } = this.props;
    if (catogary === 'models') {
      return this.renderModel();
    } else if (catogary === 'materials') {
      return this.renderMaterial();
    } else if (catogary === 'scenes') {
      return this.renderScene();
    } else {
      return null;
    }
  }
}



// WEBPACK FOOTER //
// ./src/components/PlayerContainer/index.js